import React from 'react';

const IconDropDown = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9001 5.74995C13.9001 5.86812 13.8768 5.98515 13.8315 6.09429C13.7862 6.20344 13.7198 6.30256 13.6361 6.38595L9.13607 10.886C9.05249 10.9696 8.95326 11.0359 8.84405 11.0811C8.73484 11.1264 8.61778 11.1497 8.49957 11.1497C8.38135 11.1497 8.2643 11.1264 8.15508 11.0811C8.04587 11.0359 7.94664 10.9696 7.86307 10.886L3.36307 6.38595C3.27658 6.30303 3.20753 6.20368 3.15995 6.09372C3.11237 5.98376 3.08722 5.8654 3.08599 5.7456C3.08475 5.62579 3.10745 5.50695 3.15275 5.39603C3.19805 5.28511 3.26504 5.18435 3.34979 5.09967C3.43454 5.01498 3.53535 4.94807 3.64631 4.90285C3.75726 4.85764 3.87613 4.83504 3.99593 4.83637C4.11574 4.8377 4.23407 4.86294 4.34399 4.9106C4.45392 4.95827 4.55321 5.0274 4.63607 5.11395L8.50007 8.97695L12.3631 5.11395C12.4889 4.9879 12.6493 4.90201 12.8239 4.86715C12.9986 4.83229 13.1796 4.85003 13.3442 4.91813C13.5087 4.98622 13.6494 5.10161 13.7484 5.24968C13.8473 5.39775 13.9001 5.57186 13.9001 5.74995Z"
        fill="currentColor"
      />
    </svg>
  );
};

const MemoIconDropDown = React.memo(IconDropDown);
export default MemoIconDropDown;
